import { render } from "./Gist.vue?vue&type=template&id=1c18469c"
import script from "./Gist.vue?vue&type=script&lang=js"
export * from "./Gist.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__